import * as React from "react";
import { useTheme } from "styled-components";

import { style, Icon } from "./Symbolicons";

export const MailFilled = (props: Icon): React.ReactElement => {
  const theme = useTheme();

  return (
    <svg
      style={{ ...style(props.size, props.height), ...props.style }}
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.33333 0.333313H14.6667C15.4033 0.333313 16 0.92998 16 1.66665V3.23998L8.83867 6.54531C8.306 6.79131 7.69467 6.79065 7.162 6.54531L0 3.23998V1.66665C0 0.92998 0.596667 0.333313 1.33333 0.333313ZM6.60333 7.75665C7.04667 7.96131 7.52333 8.06331 8 8.06331C8.47667 8.06331 8.95333 7.96131 9.39667 7.75665L16 4.70865V12.3333C16 13.07 15.4033 13.6666 14.6667 13.6666H1.33333C0.596667 13.6666 0 13.07 0 12.3333V4.70865L6.60333 7.75665Z"
        fill={props.color || theme.palette.blue500}
      />
    </svg>
  );
};
